import { Button } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useFlokkButtonStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 0,
  },
}));

const FlokkButton = (props) => {
  const { children } = props;
  const classes = useFlokkButtonStyles();

  return (
    <Button className={classes.root} {...props}>
      {children}
    </Button>
  );
};

export default FlokkButton;
